import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, ChevronRightIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'}`} data-id="element-145">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
          <div className="flex justify-between items-center h-16" data-id="element-147">
            <div className="flex items-center space-x-2" data-id="element-148">
              <div className="flex items-center -space-x-1.5" data-id="element-149">
                <ChevronRightIcon className="w-5 h-4 text-indigo-900 opacity-40" strokeWidth={6} data-id="element-150" />
                <ChevronRightIcon className="w-5 h-4 text-indigo-900 opacity-60" strokeWidth={6} data-id="element-151" />
                <ChevronRightIcon className="w-5 h-4 text-indigo-900" strokeWidth={6} data-id="element-152" />
              </div>
              <span className="text-xl sm:text-2xl font-bold text-indigo-900" data-id="element-153">
                Canjee
              </span>
              <span className="px-2 py-0.5 text-xs font-medium bg-amber-400 text-amber-900 rounded-full" data-id="element-154">
                Próximamente
              </span>
            </div>
            <nav className="hidden md:flex items-center space-x-8" data-id="element-155">
              <button onClick={() => scrollToSection('inicio')} className="text-sm font-medium text-gray-700 hover:text-indigo-900 transition-colors" data-id="element-156">
                Inicio
              </button>
              <button onClick={() => scrollToSection('como-funciona')} className="text-sm font-medium text-gray-700 hover:text-indigo-900 transition-colors" data-id="element-157">
                Cómo funciona
              </button>
              <button onClick={() => scrollToSection('precios')} className="text-sm font-medium text-gray-700 hover:text-indigo-900 transition-colors" data-id="element-158">
                Precios
              </button>
              <button onClick={() => scrollToSection('faq')} className="text-sm font-medium text-gray-700 hover:text-indigo-900 transition-colors" data-id="element-159">
                Preguntas
              </button>
              <button onClick={() => scrollToSection('unirme')} className="px-4 py-2 text-sm font-medium text-white bg-indigo-900 rounded-xl hover:bg-indigo-800 transition-all hover:shadow-lg" data-id="element-160">
                Unirme
              </button>
            </nav>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-gray-700 hover:text-indigo-900 transition-colors" aria-label="Toggle menu" data-id="element-161">
              {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-162" /> : <MenuIcon className="w-6 h-6" data-id="element-163" />}
            </button>
          </div>
        </div>
      </header>
      {mobileMenuOpen && <div className="fixed inset-0 z-40 md:hidden" data-id="element-164">
          <div className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm" onClick={() => setMobileMenuOpen(false)} data-id="element-165" />
          <nav className="fixed top-16 left-0 right-0 bg-white border-b border-gray-200 shadow-lg" data-id="element-166">
            <div className="px-4 py-4 space-y-3" data-id="element-167">
              <button onClick={() => scrollToSection('inicio')} className="block w-full text-left px-4 py-3 text-base font-medium text-gray-700 hover:text-indigo-900 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-168">
                Inicio
              </button>
              <button onClick={() => scrollToSection('como-funciona')} className="block w-full text-left px-4 py-3 text-base font-medium text-gray-700 hover:text-indigo-900 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-169">
                Cómo funciona
              </button>
              <button onClick={() => scrollToSection('precios')} className="block w-full text-left px-4 py-3 text-base font-medium text-gray-700 hover:text-indigo-900 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-170">
                Precios
              </button>
              <button onClick={() => scrollToSection('faq')} className="block w-full text-left px-4 py-3 text-base font-medium text-gray-700 hover:text-indigo-900 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-171">
                Preguntas
              </button>
              <button onClick={() => scrollToSection('unirme')} className="block w-full px-4 py-3 text-base font-medium text-white bg-indigo-900 rounded-lg hover:bg-indigo-800 transition-all" data-id="element-172">
                Unirme
              </button>
            </div>
          </nav>
        </div>}
    </>;
}